export const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.1';
